module.exports = __webpack_public_path__ + "img/product-img_6.79d854c5.png";